import React, { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";
import Logo from "../../images/Logo.png";
import CoralReef from "../../images/CoralReef.jpg";
import NetworkCanvas from "../NetworkCanvas";
import { unlock } from "../../service/CfriService";

/**
 * Password screen for the CFRI portal: one shared password, no account, in
 * the same layout as the sign-in page. On success the backend's pass is
 * stored (CfriService) and the page the visitor asked for opens.
 */
export default function CfriGate({ onUnlocked }) {
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!password || loading) return;
        setError("");
        setLoading(true);
        try {
            await unlock(password);
            onUnlocked();
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    return (
        <div className="auth-layout">
            <div className="auth-panel" style={{ backgroundImage: `url(${CoralReef})` }}>
                <div className="auth-panel-overlay" />
                <NetworkCanvas />
                <div className="auth-panel-content">
                    <div className="auth-logo-wrap">
                        <img src={Logo} alt="Logo" className="auth-logo" />
                    </div>
                    <h2 className="auth-panel-title">DeepThought</h2>
                    <p className="auth-panel-sub">Proposals read against the literature they belong to.</p>
                </div>
            </div>

            <div className="auth-form-side">
                <NetworkCanvas dark />
                <form className="auth-form-wrap" onSubmit={submit}>
                    <div className="cfri-gate-icon"><Lock size={18} /></div>
                    <h1 className="auth-heading">CFRI proposal review</h1>
                    <p className="auth-sub">This report was shared with you privately. Enter the password you were given to open it.</p>

                    <div className="auth-fields">
                        <div className="auth-field">
                            <label className="upload-label" htmlFor="cfri-password">Password</label>
                            <div className="auth-input-wrap">
                                <input
                                    id="cfri-password"
                                    className="upload-input"
                                    type={showPassword ? "text" : "password"}
                                    autoComplete="current-password"
                                    autoFocus
                                    value={password}
                                    onChange={(e) => { setPassword(e.target.value); setError(""); }}
                                />
                                <button
                                    type="button"
                                    className="auth-eye-btn"
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    tabIndex={-1}
                                >
                                    {showPassword ? <EyeOff size={15} /> : <Eye size={15} />}
                                </button>
                            </div>
                        </div>
                    </div>

                    {error && <p className="chpw-error" role="alert">{error}</p>}

                    <button className="auth-submit-btn" type="submit" disabled={!password || loading}>
                        {loading ? "Opening…" : "Open the report"}
                    </button>

                    <p className="auth-switch">
                        Confidential. No account needed: this browser stays signed in to the report, and you can lock it again from the menu.
                    </p>
                </form>
            </div>
        </div>
    );
}
